import styled from "styled-components";

import base from "@/themes/base/base";

export const GroupName = styled.span`
    ${base.typography.smallMedium};

    display: flex;
    padding: 0.5rem 1.25rem 0.5rem 0.75rem;
    color: ${({ theme }) => theme.colors.neutral.grey[300]};
`;

export const RoleContainer = styled.div``;

export const StatusContainer = styled.div``;

export const Divider = styled.div`
    background-color: #121212;
    height: 1px;
    margin: 0 0.75rem;
`;
